/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "../reports.module.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import { Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { withTranslation } from "react-i18next";
import currencyFormatter from "../../../../helper/currencyFormatter";
import { formatNumber } from "../../../../helper/numberFormatter";
import { formatDate } from "../../../../helper/dateFormatter";
import Chip from "@mui/material/Chip";

const SettlementTable = (props) => {
  const t = props.t;
  const getPriceTenureUOM = (val) => {
    if (val === "TF_day") {
      return "Day";
    } else if (val === "TF_hr" || val === "HOUR") {
      return "Hour";
    } else if (val === "TF_wk") {
      return "Week";
    } else if (val === "TF_mon") {
      return "Month";
    } else if (val === "TF_yr") {
      return "Year";
    } else if (val === "YEAR") {
      return "Year";
    } else if (val === "DAY") {
      return "Day";
    } else if (val === "WEEK") {
      return "Week";
    } else if (val === "MONTH") {
      return "Month";
    } else if (val === "TF_hr") {
      return "Hour";
    } else if (val === "DATA_MB") {
      return "MB";
    } else if (val === "DATA_GB") {
      return "GB";
    } else {
      return "";
    }
  };
  return (
    <div className={classes.root}>
      <TableContainer>
        {/* <Table className={classes.table} aria-label="simple table"> */}
        <Table
          className={"newGlobalTable"}
          aria-label="simple table"
          style={{ background: "white" }}
        >
          <TableHead>
            <TableRow>
              {/* {props.providerType === "SALES_CHNL_PROVIDER" && (
                <TableCell
                  className="global-custom-sorting-header"
                  onClick={(e) => {
                    props.updateSorting("settlementToPartyName");
                  }}
                >
                  <b>{t("SOLUTION_PROVIDER_NAME")}</b>
                  {props.sortBy === "settlementToPartyName" ? (
                    <span className="material-icons">
                      {props.sortOrder === "DESC"
                        ? "expand_less"
                        : "expand_more"}
                    </span>
                  ) : (
                    <span className="material-icons sorting-indicator-icon">
                      unfold_more
                    </span>
                  )}
                </TableCell>
              )} */}
              {props.providerType === "SALES_CHNL_PROVIDER" &&
                <TableCell><b>{t("PARTNER")}</b></TableCell>
              }
              {props.screen && props.screen === "customerView" ? null : (
                <TableCell
                  className="global-custom-sorting-header"
                  onClick={(e) => {
                    props.updateSorting("groupName");
                  }}
                >
                  <b>{t("CUSTOMER_NAME")}</b>
                  {/* Sort indication */}
                  {props.sortBy === "groupName" ? (
                    <span className="material-icons">
                      {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                    </span>
                  ) : (
                    <span className="material-icons sorting-indicator-icon">
                      unfold_more
                    </span>
                  )}
                </TableCell>
              )}
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("orderId");
                }}
              >
                <b>{t("ORDER_ID")}</b>
                {/* Sort indication */}
                {props.sortBy === "orderId" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("description");
                }}
              >
                <b>{t("PRODUCT_NAME")}</b>
                {/* Sort indication */}
                {props.sortBy === "description" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("priceType");
                }}
              >
                <b>{t("PRICE_TYPE")}</b>
                {/* Sort indication */}
                {props.sortBy === "amountSettled" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("quantity");
                }}
              >
                <b>{t("QUANTITY")}</b>
                {/* Sort indication */}
                {props.sortBy === "quantity" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              {/* {props.providerType === "SOLUTION_PROVIDER" && (
                <TableCell
                  className="global-custom-sorting-header"
                  onClick={(e) => {
                    props.updateSorting("settlementFromPartyName");
                  }}
                >
                  <b>{t("PARTY_NAME")}</b>
                  {props.sortBy === "settlementFromPartyName" ? (
                    <span className="material-icons">
                      {props.sortOrder === "DESC"
                        ? "expand_less"
                        : "expand_more"}
                    </span>
                  ) : (
                    <span className="material-icons sorting-indicator-icon">
                      unfold_more
                    </span>
                  )}
                </TableCell>
              )} */}
              {/* {props.screen && props.screen === "customerView" ? null : (
                <>
                  {props.providerType === "SALES_CHNL_PROVIDER" && (
                    <TableCell
                      className="global-custom-sorting-header"
                      onClick={(e) => {
                        props.updateSorting("customerBan");
                      }}
                    >
                      <b>{t("CUSTOMER_BAN")}</b>
                      {props.sortBy === "customerBan" ? (
                        <span className="material-icons">
                          {props.sortOrder === "DESC"
                            ? "expand_less"
                            : "expand_more"}
                        </span>
                      ) : (
                        <span className="material-icons sorting-indicator-icon">
                          unfold_more
                        </span>
                      )}
                    </TableCell>
                  )}
                </>
              )} */}

              {/* show only for Opco start */}
              {props.providerType === "SALES_CHNL_PROVIDER" && !props.tenantRoles.includes("MASTER_PROVIDER") && (
                <>
                  <TableCell>
                    <b>
                      {t("TOTAL_REVENUE")} ($)
                    </b>
                  </TableCell>
                  <TableCell>
                    <b>{t("TRANSFER_PRICE")} ($)</b>
                  </TableCell>
                  <TableCell>
                    <b>{t("3RD_PARTY")} ($)</b>
                  </TableCell>
                  <TableCell>
                    <b>{t("OPCO_COST")} ($)</b>
                  </TableCell>
                  <TableCell>
                    <b>{t("TOTAL_COS")} ($)</b>
                  </TableCell>
                </>
              )}
              {/* show only for Opco end */}

              {props.providerType === "SALES_CHNL_PROVIDER" && (
                <>
                  {props.tenantRoles.includes("MASTER_PROVIDER") ?
                    props.tabValue === 2 && <>
                      <TableCell>
                        <b>
                          {t("TOTAL_REVENUE")}
                        </b>
                      </TableCell>
                      <TableCell>
                        <b>{t("TRANSFER_PRICE")}</b>
                      </TableCell>
                    </>
                    :
                    <>
                      <TableCell>
                        <b>{t("TOTAL_REVENUE")} ({currencyFormatter(0, false)})</b>
                      </TableCell>
                      <TableCell>
                        <b>{t("TRANSFER_PRICE")} ({currencyFormatter(0, false)})</b>
                      </TableCell>
                    </>
                  }
                </>
              )}
              <TableCell
              // className="global-custom-sorting-header"
              // onClick={(e) => {
              //   props.updateSorting("thirdPartyPrice");
              // }}
              >
                {props.providerType === "SALES_CHNL_PROVIDER" &&
                  <b>{t("3RD_PARTY")} {props.tenantRoles.includes("MASTER_PROVIDER") ? '' : '(' + currencyFormatter(0, false) + ')'}</b>
                }
                {props.providerType === "SOLUTION_PROVIDER" &&
                  <b>{t("PRICE")}</b>
                }
                {/* Sort indication */}
                {/* {props.sortBy === "thirdPartyPrice" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )} */}
              </TableCell>
              {props.providerType === "SALES_CHNL_PROVIDER" && (
                <>
                  {props.tenantRoles.includes("MASTER_PROVIDER") ?
                    props.tabValue === 2 && <>
                      <TableCell>{t('OPCO_COST')}</TableCell>
                      <TableCell>{t('TOTAL_COS')}</TableCell>
                    </>
                    :
                    <>
                      <TableCell>{t('OPCO_COST')} ({currencyFormatter(0, false)})</TableCell>
                      <TableCell>{t('TOTAL_COS')} ({currencyFormatter(0, false)})</TableCell>
                    </>
                  }
                </>
              )}
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("invoiceId");
                }}
              >
                <b>{t("INVOICE_NO")}</b>
                {/* Sort indication */}
                {props.sortBy === "invoiceId" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("invoiceDate");
                }}
              >
                <b>{t("INVOICE_DATE")}</b>
                {/* Sort indication */}
                {props.sortBy === "invoiceDate" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("paidDate");
                }}
              >
                <b>{t("INVOICE_PAID_DATE")}</b>
                {/* Sort indication */}
                {props.sortBy === "paidDate" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("statusId");
                }}
              >
                {t('STATUS')}
                {props.sortBy === "statusId" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Show settlements list */}
            {props.list.map((row, index) => (
              <TableRow
                key={index}
                style={{ cursor: "default" }}
                className={classes.rowClass}
              >
                {/* {props.providerType === "SALES_CHNL_PROVIDER" && (
                  <TableCell>{row.settlementToPartyName}</TableCell>
                )} */}
                {props.providerType === "SALES_CHNL_PROVIDER" &&
                  <TableCell>{row.partnerName}</TableCell>
                }
                {props.screen && props.screen === "customerView" ? null : (
                  <TableCell>{row.businessName}</TableCell>
                )}
                <TableCell>{row.orderId}</TableCell>
                <TableCell>{row.serviceName}</TableCell>
                <TableCell>
                  {row.chargeType &&
                    (row.chargeType === "RECURRING_CHARGE"
                      ? row.termAmount && row.termUomId
                        ? row.termAmount > 1
                          ? `${t(row.chargeType)} (${row.termAmount} ${getPriceTenureUOM(row.termUomId)})`
                          : `${t(row.chargeType)} (per ${getPriceTenureUOM(row.termUomId)})`
                        : t(row.chargeType)
                      : row.chargeType === "PURCHASE"
                        ? t("NON_RECURRING_CHARGE")
                        : t(row.chargeType))}
                </TableCell>
                <TableCell>{row.quantity}</TableCell>
                {/* {props.providerType === "SOLUTION_PROVIDER" && (
                  <TableCell>{row.accountName}</TableCell>
                )} */}
                {/* {props.screen && props.screen === "customerView" ? null : (
                  <>
                    {props.providerType === "SALES_CHNL_PROVIDER" && (
                      <TableCell>{row.customerBan}</TableCell>
                    )}
                  </>
                )} */}

                {/* Only for Opco start */}
                {props.providerType === "SALES_CHNL_PROVIDER" && !props.tenantRoles.includes("MASTER_PROVIDER") && (
                  <>
                    <TableCell>
                      {currencyFormatter(row.totalRevenueConverted, null, true)}
                    </TableCell>
                    <TableCell>
                      {currencyFormatter(row.transferPriceConverted, null, true)}
                    </TableCell>
                    <TableCell>
                      {currencyFormatter(row.thirdPartyPriceConverted, null, true)}
                    </TableCell>
                    <TableCell>
                      {currencyFormatter(row.opcoAmountConverted, null, true)}
                    </TableCell>
                    <TableCell>
                      {currencyFormatter(row.totalCosConverted, null, true)}
                    </TableCell>
                  </>
                )}
                {/* Only for Opco end */}

                {props.providerType === "SALES_CHNL_PROVIDER" && (
                  <>
                    {props.tenantRoles.includes("MASTER_PROVIDER") ?
                      props.tabValue === 2 && <TableCell>{currencyFormatter(row.totalRevenue)}</TableCell>
                      :
                      <TableCell>{currencyFormatter(row.totalRevenue)}</TableCell>
                    }
                  </>
                )}
                {props.providerType === "SALES_CHNL_PROVIDER" &&
                  <>
                    {props.tenantRoles.includes("MASTER_PROVIDER") ?
                      props.tabValue === 2 && <TableCell>
                        {row.transferPrice
                          ? currencyFormatter(row.transferPrice)
                          : currencyFormatter("", false) + " 0.00"}
                      </TableCell>
                      :
                      <TableCell>
                        {row.transferPrice
                          ? currencyFormatter(row.transferPrice)
                          : currencyFormatter("", false) + " 0.00"}
                      </TableCell>
                    }
                  </>
                }
                <TableCell>
                  {row.thirdPartyPrice
                    ? currencyFormatter(row.thirdPartyPrice)
                    : currencyFormatter("", false) + " 0.00"}
                </TableCell>
                {props.providerType === "SALES_CHNL_PROVIDER" &&
                  <>
                    {props.tenantRoles.includes("MASTER_PROVIDER") ?
                      props.tabValue === 2 && <TableCell>
                        {row.opcoAmount
                          ? currencyFormatter(row.opcoAmount)
                          : currencyFormatter("", false) + " 0.00"}
                      </TableCell>
                      :
                      <TableCell>
                        {row.opcoAmount
                          ? currencyFormatter(row.opcoAmount)
                          : currencyFormatter("", false) + " 0.00"}
                      </TableCell>
                    }
                  </>
                }
                {props.providerType === "SALES_CHNL_PROVIDER" &&
                  <>
                    {props.tenantRoles.includes("MASTER_PROVIDER") ?
                      props.tabValue === 2 && <TableCell>
                        {row.totalCos
                          ? currencyFormatter(row.totalCos)
                          : currencyFormatter("", false) + " 0.00"}
                      </TableCell>
                      :
                      <TableCell>
                        {row.totalCos
                          ? currencyFormatter(row.totalCos)
                          : currencyFormatter("", false) + " 0.00"}
                      </TableCell>
                    }
                  </>
                }
                {/* <TableCell>{row.priceType ? row.priceType === 'PURCHASE' ? t('NRC_FULL') : t(row.priceType) : ''}</TableCell> */}
                <TableCell>{row.invoiceId}</TableCell>
                <TableCell>
                  {formatDate(row.invoiceDate)}
                </TableCell>
                <TableCell>
                  {row.paidDate ? formatDate(row.paidDate) : '-'}
                </TableCell>
                <TableCell>
                  <Chip
                    size="normal"
                    className={
                      row.status === "Paid"
                        ? "successChip"
                        : "inProgressChip"
                    }
                    label={row.status}
                  />
                </TableCell>
              </TableRow>
            ))}
            {/* If there is no settlements to show */}
            {props.list.length === 0 && (
              <TableRow>
                <TableCell colSpan={12} align="center">
                  {t("NO_SETTLEMENT_FOUND")}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {props.totalSettlementCount > 0 && (
        <div
          className="global-custom-pagination"
          style={{ background: "rgba(196, 196, 196, 0.2)" }}
        >
          <label style={{ float: "left", padding: "5px" }}>
            {t("TOTAL_RECORDS")}: {formatNumber(props.totalSettlementCount)}
          </label>
          <label>
            {t("ROWS_PER_PAGE")}:
            <Select
              value={props.rowsPerPage}
              onChange={props.handleChangeRowsPerPage}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </label>
          <Pagination
            count={Math.ceil(props.totalSettlementCount / props.rowsPerPage)}
            onChange={props.handleChangePage}
            page={props.page}
            showFirstButton
            showLastButton
          />
        </div>
      )}
    </div>
  );
};

export default withTranslation("translations")(SettlementTable);
